import React from 'react';
import _ from 'lodash';
import { CSVLink } from 'react-csv';
import Button from '../form/Button';

let csvHeaders = [
  { label: 'Organization', key: 'org_name' },
  { label: 'Practice', key: 'practice_name' },
  { label: 'Concept', key: 'concept_code' },
  { label: 'Code', key: 'criteria_code' },
  { label: 'Action', key: 'action' },
  { label: 'Log', key: 'value' },
  { label: 'Email', key: 'user_id' },
  { label: 'Date', key: 'created_at' },
];

const CSVButton = ({ data, fetchCSVData, loading }) => {
  
    if(loading === 1) {
        return (
            <div className="Button-danger">
                <Button clasName="Button-disabled" defaultText="Loading CSV Data... Please Wait" />
            </div>
        )
    }
    
    if (_.isEmpty(data) || loading === 0) {
      return (
        <Button defaultText="Generate CSV" onClick={fetchCSVData} />
      )
    } 
    
    if(loading === 2)
    {
      return (
        <div className="Button-success">
        <CSVLink
          className="csv-download"
          target="_self"
          filename={'activity-log.csv'}
          data={data}
          headers={csvHeaders}
        >
            <Button defaultText="Download CSV" />
        </CSVLink>
        </div>
      )
    }
  }

  export default CSVButton;